import { QueryHookOptions } from '@apollo/client';
import { SelectOption } from '@anytag/shared-types';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, QueryallBankBranchesArgs, useAllBankBranchesQuery } from '@anytag/graphql';

export const useAllBankBrandOptions = (options?: QueryHookOptions<Query, QueryallBankBranchesArgs>) => {
  const { data, loading } = useAllBankBranchesQuery({ fetchPolicy: 'cache-first', ...options });

  return {
    loading,
    allBankBranchOptions: getSelectOptions(data?.allBankBranches),
    allBankBranchNameOptions:
      data?.allBankBranches?.map<SelectOption<string>>((branch) => ({
        label: branch?.name || '',
        value: branch?.name || ''
      })) || []
  };
};
